import { Box, Stack, Typography } from '@mui/material'
import { orange } from '@wolfdanepug/common-react'

export const LandingBlock = ({ title, text, image, sx }: any) => (
	<Stack
		gap={4}
		sx={{ py: 8, px: 6, alignItems: 'center', position: 'relative', border: '1px solid #ebebeb' }}
	>
		<Box sx={{ position: 'absolute', top: 0, left: '50%', transform: 'translate(-50%, -60%)' }}>
			<Box sx={{ width: 84, height: 84, bgcolor: orange, borderRadius: '50%', opacity: 0.8 }} />
			<Box
				component={'img'}
				src={`/get-started/img/${image}`}
				alt={title}
				sx={{
					position: 'absolute',
					top: '60%',
					left: '50%',
					transform: 'translate(-50%, -50%)',
					maxWidth: 'none',
					...sx.image
				}}
			/>
		</Box>
		<Typography color="primary" variant="h3" sx={{ fontSize: 24 }}>
			{title}
		</Typography>
		<Typography
			variant="body1"
			sx={{ textAlign: 'center', fontSize: 18 }}
			dangerouslySetInnerHTML={{ __html: text }}
		/>
	</Stack>
)
